import $ from 'jquery';

export default class AR_Slider {
    constructor() {
        $('.ar__slider').each((i, e) => {
            const $e = $(e);
            let imgs = $e.find('img').length;
            const config = {
                arrows: true,
                swipeToSlide: true,
                slidesToShow: 3,
                lazyLoad: 'progressive',
                responsive: [
                    {
                        breakpoint: 920,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 1,
                        }
                    },
                ]
            };
            const reInit = () => {
                if (+$e.attr('data-off') === 1) return;
                imgs = $e.find('img').length;
                if ($e.hasClass('slick-initialized')) {
                    $e.slick('destroy');
                    $e.slick(config);
                }
                $(window).trigger('resize');
            };
            if (+$e.attr('data-off') !== 1) {
                $e.slick(config).on('lazyLoaded', (event, slick, image, imageSource) => {
                    if (--imgs === 0){
                        this.clear($e);
                        this.calc($e);
                        reInit();
                    }
                });
                // $e.find('img').each((i, e) => {
                //     if (e.complete) {
                //         reInit();
                //     } else {
                //         e.addEventListener('load', reInit);
                //     }
                // });
            } else {
                this.calc2($e);
                let resizing = false;
                $(window).on('resize', () => {
                    this.clear($e);
                    if (resizing) clearTimeout(resizing);
                    resizing = setTimeout(() => {
                        this.calc2($e);
                    }, 100);
                });
                return;
            }
            this.calc($e);
            let resizing = false;
            $(window).on('resize', () => {
                this.clear($e);
                if (resizing) clearTimeout(resizing);
                resizing = setTimeout(() => {
                    this.calc($e);
                }, 100);
            });
        });
    }

    calc($e) {
        let h = 0;
        let initH = $e.find('.ar__artist-image').height();
        $e.find('img').each((ii, ee) => {
            const $ee = $(ee);
            if ($ee.height() > h) h = $ee.height();
            // $ee.css('max-height', '100%');
        });
        const offset = Math.abs(h - initH);
        $e.find('.slick-arrow').css('top', initH / 2 + offset + 'px').css('transform', 'unset');
        $e.find('.ar__artist-image').css('height', h + 'px');
        $e.css('margin-top', offset * -1 + 'px');
        $e.prev('.ar__bg').css('top', offset + 'px').css('height', 'calc(100% - ' + offset + 'px)');
        // $e.parent('.ar__artists').css('background-position-y', offset + 'px');
        $e.prevAll('.ar__white').css('height', offset + 'px');
        setTimeout(() => {
            $e.find('img').each((ii, ee) => {
                const $ee = $(ee);
                $ee.css('max-height', '100%');
            });
        }, 100);
    }
    clear($e) {
        $e.removeAttr('style');
        $e.find('img').removeAttr('style');
        $e.find('.ar__artist-image').removeAttr('style');
    }
    calc2($e) {
        $e.find('.ar__artist-image').each((i, e) => {
            const $ee = $(e);
            const initH = $ee.height();
            let maxH = 0;
            let ix = 0;
            let j = 0;
            $ee.find('img').each((i, ee) => {
                const $img = $(ee);
                $img.on('load', () => {
                    if ($img.height() > maxH) maxH = $img.height();
                    if (++ix === $ee.find('img').length) {
                        $ee.parent().next('.ar__gallery').find('.ar__gallery-wrapper').css('height', initH + 'px');
                        $ee.parent().css('padding-top', maxH - $ee.height() + 'px');
                        $ee.parent().next('.ar__gallery').css('padding-top', maxH - $ee.height() + 'px');
                    }
                });
                if ($img[0].complete) {
                    $img.trigger('load');
                }
            });
        });
    }
}